<template>
  <vs-popup id="popupSignField" :title="$t('서명')" :active.sync="showPopup">
    <div>
      <div v-if="!image && !readonly" class="grid xl:flex justify-end gap-2 mb-2" style="grid-template-columns: 1fr 1fr">
        <vs-button class="xl:mr-auto" color="secondary" @click.prevent="handleClickLoadSign">{{ $t("내 서명 불러오기") }}</vs-button>
        <template v-if="isMobile">
          <vs-button color="secondary" type="border" @click.prevent="$refs.VueCanvasDrawing.undo()">{{ $t("실행취소") }}</vs-button>
          <vs-button color="secondary" type="border" @click.prevent="$refs.VueCanvasDrawing.redo()">{{ $t("다시실행") }}</vs-button>
          <vs-button color="secondary" @click.prevent="$refs.VueCanvasDrawing.reset()">{{ $t("초기화") }}</vs-button>
        </template>
      </div>
      <div v-if="image" style="text-align: center">
        <div
          class="sign-img"
          :style="{
            backgroundImage: `url(${image})`,
            width: canvas_width + 'px',
            height: canvas_height + 'px',
          }"
        ></div>
        <!--        <img v-if="image" height="270" :src="image" style="display: inline-block; content: ''; border: 1px solid #cdcdcd;"/>-->
      </div>
      <div v-else-if="!isMobile && !readonly" class="sign-disabled-area">
        <div class="sign-disabled-content">
          <div class="sign-disabled-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 17.5V21h3.5L17.81 9.69l-3.5-3.5L3 17.5z" fill="#4A5568" />
              <path d="M20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="#4A5568" />
              <circle cx="7" cy="7" r="1.5" fill="#718096" opacity="0.6" />
              <circle cx="12" cy="12" r="1" fill="#718096" opacity="0.4" />
              <circle cx="17" cy="17" r="0.8" fill="#718096" opacity="0.3" />
            </svg>
          </div>
          <div class="sign-disabled-message">
            <div class="sign-disabled-title">{{ $t("모바일에서 서명 가능") }}</div>
            <div class="sign-disabled-desc">{{ $t('"내 서명 불러오기" 기능을 사용하시거나') }}<br />{{ $t("모바일 환경에서 서명해주세요.") }}'</div>
          </div>
        </div>
      </div>
      <vue-drawing-canvas
        v-else-if="this.showPopup && (isMobile || readonly)"
        ref="VueCanvasDrawing"
        :image.sync="useImage"
        :width="canvas_width"
        :height="canvas_height"
        :lineWidth="8"
        stroke-type="dash"
        line-cap="round"
        line-join="round"
        :fill-shape="false"
        :eraser="false"
        color="#000000"
        background-color="transparent"
        saveAs="png"
        :styles="{ border: 'solid 1px #cdcdcd' }"
        :lock="readonly"
      />
      <div v-if="!readonly" class="flex justify-end gap-2">
        <vs-button v-if="image" @click="handleDelete">{{ $t("삭제") }}</vs-button>
        <vs-button v-else-if="isMobile" @click="handleSave">{{ $t("적용") }}</vs-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import VueDrawingCanvas from "vue-drawing-canvas";

export default {
  name: "PopupSignField",
  components: {
    VueDrawingCanvas,
  },
  props: {
    value: Boolean,
    image: String,
    selectId: [String, Number],
    readonly: Boolean,
  },
  computed: {
    isMobile() {
      return this.detectMobile();
    },
  },
  watch: {
    value(data) {
      this.showPopup = data;
    },
    showPopup(data) {
      this.$emit("input", data);
    },
  },
  data() {
    return {
      showPopup: false,
      canvas_width: 570,
      canvas_height: 270,
      useImage: "",
    };
  },

  mounted() {
    this.updateCanvasSize();
    window.addEventListener("resize", this.updateCanvasSize);

    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showPopup) {
        this.showPopup = false;
        next(false);
        return;
      }
      next(true);
    });
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard();
    });
  },

  created() {
    this.showPopup = this.value;
    this.oldSelectCompanyId = this.selectId;
  },

  methods: {
    detectMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(userAgent);
    },
    updateCanvasSize() {
      const maxWidth = 570;
      const margin = 60; // 여유 공간
      const screenWidth = window.innerWidth - margin;
      this.canvas_width = screenWidth < maxWidth ? screenWidth : maxWidth;
      this.canvas_height = (this.canvas_width * 270) / 570;
    },
    async loadCompanyList() {
      const page = this.page.current;
      const perPage = this.page.perPage;
      const keyword = this.search.keyword;
      const projectId = this.projectId;
      await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
        page,
        perPage,
        keyword,
        projectId,
      });
    },

    loadSign(callback) {
      const options = {
        name: "",
      };
      this.$store
        .dispatch("member/LOAD_SIGNATURE", options)
        .then((signList) => {
          let defualtSign = undefined;
          for (let i = 0; i < signList.length; i++) {
            if (signList[i].is_default) {
              defualtSign = signList[i];
              break;
            }
          }
          if (callback) {
            callback(defualtSign);
          }
        })
        .catch((error) => {
          const customAlert = new CustomEvent("customAlert", {
            detail: {
              title: this.$t("에러"),
              message: error,
            },
          });
          window.dispatchEvent(customAlert);
        });
    },

    handleClickLoadSign() {
      this.loadSign((data) => {
        if (data && data.file) {
          this.$emit("update", data.file.path);
          this.$toast.open({
            type: "default",
            message: this.$t("내 서명을 불러왔습니다."),
            position: "bottom",
            duration: 2000,
          });
        } else {
          this.$emit("update", false);
          this.$toast.open({
            type: "warning",
            message:  this.$t("저장된 서명이 없습니다. 먼저 서명을 등록해주세요."),
            position: "bottom",
            duration: 3000,
          });
        }
      });
    },

    handleClickClose() {
      this.$emit("input", false);
      this.$emit("handleClickClose");
    },

    handleSave() {
      this.$emit("save", this.useImage);
      this.showPopup = false;
      this.$toast.open({
        type: "default",
        message: this.$t("서명이 저장되었습니다."),
        position: "bottom",
        duration: 2000,
      });
    },

    handleDelete() {
      this.$emit("delete");
      this.showPopup = false;
      this.$toast.open({
        type: "default",
        message: this.$t("서명이 삭제되었습니다."),
        position: "bottom",
        duration: 2000,
      });
    },
  },
};
</script>

<style>
#popupSignField > .vs-popup {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>

<style scoped>
.sign-img {
  width: 570px;
  height: 270px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
  border: 1px solid #cdcdcd;
  margin-bottom: 10px;
}

.sign-disabled-area {
  width: 570px;
  height: 270px;
  max-width: 100%;
  background: linear-gradient(135deg, #eaeaea 0%, #e3e3e3 100%);
  border: 1px solid #b8b8b8;
  border-radius: 12px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
}

.sign-disabled-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
}

.sign-disabled-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #fff 0%, #f8f8f8 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(255, 255, 255, 0.8);
}

.sign-disabled-message {
  color: #444;
  text-align: center;
  line-height: 1.6;
}

.sign-disabled-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}

.sign-disabled-desc {
  font-size: 14px;
  color: #555;
  opacity: 0.9;
}
</style>
